/* global process */
/**
 * define configuration options here
 */
import { getTenant } from "./js/moderator/utils/tenant.js";

const tenant = getTenant();

export const url = {
	protocol : "http",
	hostname : "localhost",
	port : "8000",
	// api_base_path: isLocal
	// 	? "/"
	// 	: "https://portal.floorwalk.in/",
	api_base_path: process.env.NODE_ENV === "development"
		? "/"
		: tenant.baseUrl,
};

export const momentDateFormat = "Do MMM YYYY";
export const momentDateTimeFormat = "hh:mm Do MMM YYYY";
export const momentDateTimeFormat1 = "hh:mm A Do MMM YYYY";

export const demo = false;

